"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
var _reactI18next = require("react-i18next");
var _mui = require("tss-react/mui");
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _Button = _interopRequireDefault(require("../Button"));
var _MultilanguageFieldInputs = _interopRequireDefault(require("../MultilanguageFieldInputs"));
var _excluded = ["languages", "name", "value", "handleChange", "className", "errors"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: {
      display: 'flex',
      gap: theme.spacing(2, 2)
    },
    emptyCard: {
      display: 'flex',
      alignItems: 'center',
      width: 206,
      padding: theme.spacing(2),
      boxShadow: theme.customShadows.small,
      borderRadius: 10
    }
  };
});
var MultilanguageOptionsInput = function MultilanguageOptionsInput(_ref) {
  var languages = _ref.languages,
    name = _ref.name,
    value = _ref.value,
    _handleChange = _ref.handleChange,
    className = _ref.className,
    errors = _ref.errors,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useTranslation = (0, _reactI18next.useTranslation)('multilanguageInputs'),
    t = _useTranslation.t;
  var onDelete = function onDelete(index) {
    var newValue = _toConsumableArray(value);
    newValue.splice(index, 1);
    _handleChange(newValue);
  };
  var emptyValues = function emptyValues() {
    var val = {
      uuid: (0, _uuid.v4)()
    };
    languages.forEach(function (_ref2) {
      var locale = _ref2.locale;
      val[locale] = '';
    });
    return val;
  };
  (0, _react.useEffect)(function () {
    if (!value.length) _handleChange([emptyValues()]);
  }, [_handleChange, value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx(classes.root, className)
  }, !!value.length && value.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(_MultilanguageFieldInputs["default"], _extends({
      key: option.uuid,
      name: "".concat(name, "-").concat(index + 1),
      label: "".concat(t('option'), " #").concat(index + 1),
      value: option,
      languages: languages,
      errors: errors[index],
      handleChange: function handleChange(optionValue) {
        var newValues = _toConsumableArray(value);
        newValues[index] = optionValue;
        _handleChange(newValues);
      },
      onDelete: value.length > 1 ? function () {
        return onDelete(index);
      } : undefined
    }, other));
  }), /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: classes.emptyCard
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "secondary",
    onClick: function onClick() {
      return _handleChange([].concat(_toConsumableArray(value), [emptyValues()]));
    }
  }, t('addOption'))));
};
MultilanguageOptionsInput.propTypes = {
  value: _propTypes["default"].arrayOf(_propTypes["default"].objectOf(_propTypes["default"].string)),
  handleChange: _propTypes["default"].func.isRequired,
  languages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    locale: _propTypes["default"].string,
    code: _propTypes["default"].string,
    label: _propTypes["default"].string
  })).isRequired,
  name: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  errors: _propTypes["default"].arrayOf(_propTypes["default"].objectOf(_propTypes["default"].objectOf(_propTypes["default"].string)))
};
MultilanguageOptionsInput.defaultProps = {
  className: undefined,
  errors: [],
  value: []
};
var _default = MultilanguageOptionsInput;
exports["default"] = _default;